var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('side-menu'),_c('toolbar'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view'),_c('pre',[_vm._v(_vm._s(_vm.getCurrentUser))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }